import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addCondition } from '../../../data/actions/query';
import { useConditions } from '../../../data/hooks/query';
import CategorySelection from './CategorySelection/CategorySelection';

function AddCondition(props) {
    const {} = props,
        [showCategoriesSelection, setShowCategoriesSelection] = useState(false),
        dispatch = useDispatch(),
        conditions = useConditions();

    const handleAddCondition = useCallback((categoryId) => {
            setShowCategoriesSelection(false);
            dispatch(addCondition(categoryId));
        }, []),
        handleShowAddConditionClicked = useCallback((e) => setShowCategoriesSelection(true), []);

    if (!conditions.length || showCategoriesSelection) {
        return <CategorySelection onSelect={handleAddCondition} />;
    }

    return (
        <div>
            <button type="button" className="btn btn-dark btn-round" onClick={handleShowAddConditionClicked}>
                Add condition
            </button>
        </div>
    );
}

export default AddCondition;
